<template>
  <div class="template-maker">
    <div v-if="!preview" class="tools-zone">
      <div>
        {{$t('dash.template.title')}}:
        <vs-select
          :color="textProperties.color"
          :label="$t('dash.template.color')"
          v-model="textProperties.color"
          :style="{color: textProperties.color === '#FFFFFF' ? 'black' : textProperties.color}"
        >
          <vs-select-item :key="item.value" :value="item.hex" :text="item.value" v-for="item in possiblesColors" />
        </vs-select> 
        <vs-select
            :label="$t('dash.template.size')"
            v-model="textProperties.size"
          >
          <vs-select-item :key="item" :value="item" :text="item" v-for="item in possiblesSizes" />
        </vs-select>
        <vs-select
            :label="$t('dash.template.font')"
            v-model="textProperties.font"
          >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in possiblesFonts" />
        </vs-select>
      </div>
      <div style="display: flex; alignItems: center;">
        {{$t('dash.template.background')}}: 
          <input style="margin-left: 10px" type="color" v-model="backgroundColor">
      </div>
      <div class="custom_link" >
        {{$t('dash.template.custom_link')}}
          <input type="text" v-model="custom_cta">
      </div>
      <!-- <div style="display: flex; alignItems: center;">
        {{$t('dash.template.image')}}: 
          <vs-switch color="dark" vs-icon-on="check_box" vs-icon-off="block" @click.prevent >
            <span slot="on">Cover</span>
            <span slot="off">Contain</span>
          </vs-switch>
      </div> -->
      
      <div>
        {{$t('dash.template.layers')}}:
          <label class="layers-config">
            <div class="add-layer">Add new layer</div>
            <input type="file" accept="image/*" @change="addNewLayer($event, index)">
          </label>
          <div class="layers-preview">
            <div class="layer-preview" v-for="(layer, i) in layers" :key="i" >
              <span class="remove-layer" @click="removeLayer(i)">x</span>
              <img :src="layer.reader || layer.url" :alt="i">
            </div>
          </div>
        </div>

      <!-- <div style="cursor: pointer; border: 1px solid black; backgroundColor: white;" @click="testTemplateBack">SEND TEST</div> -->
    </div>
    <div id="template-zone" class="template-zone" :style="{backgroundColor, marginLeft: preview && '0px'}">
      <p :style="{color: textProperties.color, fontSize: textProperties.size+'px'}" :class="`title-news font${textProperties.font}`">{{title ? title : 'Test de titre'}}</p>
      <img
        class="image-news"
        :src="image ? image : require('../../assets/img/template_image.jpg')"
        alt="IMAGE"
      />
      <img class="image-layer" :id="`layer-${i}`" v-for="(layer, i) in layers" :key="i" :src="layer.reader || layer.url" :alt="i">
      <div id="link-container" class="link-container"> 
        <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
        <p class="link-txt">{{custom_cta ? custom_cta.toUpperCase() : (link ? link.split('/')[2].toUpperCase() : 'LINK.COM')}}</p>
      </div>
      <!-- <story-maker :screenWidth="281" :screenHeight="500"></story-maker> -->
    </div>
  </div>
</template>

<script>
// import StoryMaker from './StoryMaker.vue'
import interact from 'interactjs'


export default {
  components: {  },

  mounted() {
    if (this.configuration) {
      this.layers = this.configuration.layers.map(e => {
        return {
          x: e.x/3.84,
          y: e.y/3.84,
          w: e.w/3.84,
          h: e.h/3.84,
          url: e.url
        };
      });
      if (this.configuration.link.custom_cta) {
        this.custom_cta = this.configuration.link.custom_cta;
      }
      this.backgroundColor = this.configuration.background;
      this.textProperties = {
        color: this.configuration.text.color,
        size: this.configuration.text.size,
        font: this.configuration.text.font,
        background: this.configuration.text.background
      };
      let img = document.getElementsByClassName('image-news')[0];
      let txtEl = document.getElementsByClassName('title-news')[0];
      let linkEl = document.getElementById('link-container');

      img.style.width = `${this.configuration.image.w / 3.84}px`;
      img.style.height = `${this.configuration.image.h / 3.84}px`;
      img.style.left = `${this.configuration.image.x / 3.84}px`;
      img.style.top = `${this.configuration.image.y / 3.84}px`;

      if (this.preview) {
        txtEl.style.left = `${(this.configuration.text.x / 5.12)}px`
        txtEl.style.top = `${(this.configuration.text.y / 5.12)}px`
        txtEl.style.transform = 'translate(-50%, -50%)';
        this.textProperties.size = this.textProperties.size * (30/this.title.length) + (this.title.length*0.01)
      } else {
        txtEl.style.left = `${((this.configuration.text.x / 5.12) - (this.configuration.text.w / 5.12 / 2))}px`
        txtEl.style.top = `${((this.configuration.text.y / 5.12) - (this.configuration.text.h / 5.12 / 2))}px`
      }
      if (this.preview) {
        linkEl.style.left = `${(this.configuration.link.x / 5.12)}px`
        linkEl.style.top = `${(this.configuration.link.y / 5.12)}px`
        linkEl.style.transform = 'translate(-50%, -50%)';
      } else {
        linkEl.style.left = `${((this.configuration.link.x / 5.12) - (this.configuration.link.w / 5.12 / 2))}px`
        linkEl.style.top = `${((this.configuration.link.y / 5.12) - (this.configuration.link.h / 5.12 / 2))}px`
      }

      this.$nextTick(_ => {
        this.layers.forEach((e,i) => {
          let elmt = document.getElementById(`layer-${i}`);
          elmt.style.width = `${e.w}px`;
          elmt.style.height = `${e.h}px`;
          elmt.style.left = `${e.x}px`;
          elmt.style.top = `${e.y}px`;
        });
      })
      
    }
    if (!this.preview) {
      interact('.image-news')
        .resizable({
          edges: { left: true, right: true, bottom: true, top: true },
          listeners: { move: this.imageResizeHandle },
          modifiers: [
            interact.modifiers.restrictEdges({
              outer: 'parent',
            }),
            interact.modifiers.restrictSize({
              min: { width: 100, height: 50 }
            })
          ]
        })
        .draggable({
          listeners: { move: this.imageDragHandle },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });

        interact('.image-layer')
        .resizable({
          edges: { left: true, right: false, bottom: false, top: true },
          listeners: { move: this.imageResizeHandle },
          modifiers: [
            interact.modifiers.restrictEdges({
              outer: 'parent',
            }),
            interact.modifiers.restrictSize({
              min: { width: 20, height: 20 },
              // max: { width: 300, height: 200 }
            })
          ]
        })
        .draggable({
          listeners: { move: this.imageDragHandle },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
      
      interact('.title-news')
        .draggable({
          listeners: { move: this.imageDragHandle },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
      
      interact('.link-container')
      .draggable({
        listeners: {move: this.imageDragHandle},
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent'
          })
        ]
      })
    }
  },

  props: {
    configuration: Object,
    image: {type: String, default: null},
    title: {type: String, default: null},
    link: {type: String, default: null},
    preview: {type: Boolean, default: false},
  },

  data() {
    return {
      possiblesColors: [
        {value: this.$t('instagram.color.white'), hex: "#FFFFFF"},
        {value: this.$t('instagram.color.yellow'), hex: "#fdcb5c"},
        {value: this.$t('instagram.color.orange'), hex: "#fd8d32"},
        {value: this.$t('instagram.color.red'), hex: "#db565b"},
        {value: this.$t('instagram.color.pink'), hex: "#d10869"},
        {value: this.$t('instagram.color.purple'), hex: "#a207ba"},
        {value: this.$t('instagram.color.blue'), hex: "#0095ff"},
        {value: this.$t('instagram.color.green'), hex: "#58c322"},
        {value: this.$t('instagram.color.black'), hex: "#000000"},
      ],

      possiblesSizes: [ ...Array(22).keys() ].map(e => e + 12).filter(e => e % 2 === 0),

      possiblesFonts: [
        {text: 'font 1', value: 1},
        {text: 'font 2', value: 2},
        {text: 'font 3', value: 3},
        {text: 'font 4', value: 4},
        // {text: 'font 5', value: 5},
        // {text: 'font 6', value: 6},
        // {text: 'font 7', value: 7},
        // {text: 'font 8', value: 8},
        // {text: 'font 9', value: 9},
      ],

      textProperties: {
        color: '#FFFFFF',
        size: 22,
        font: 1,
        background: null
      },

      layers: [],

      backgroundColor: '#000000',

      custom_cta: '',
      
    }
  },

  methods: {

/**
 * Faire une methode qui permet de recuperer les info
 * Dans Bot au moment de la validation recuperer info en appelant la methode (desssus)
 * Puis envoyer crééer la template en appelant l'engine
 * et ajouter à StoryTemplate en bdd, les info : layer(x, y ,w, h, url), image(x,y,w,h), text(x,y,font,size,color), link(x,y)
 * Lors d'un post (lambda B + engine post) recuperer les info en BDD
 * Si template configuré alors utilisé les info pour construire les image et set le variable text et link
 * Modifier pour que la template 1 fonctionne de la meme maniere ? 
 * 
 */

    async testTemplateBack() {
      let img = document.getElementsByClassName('image-news')[0];

      let image = {
          x: parseInt((img.offsetLeft + parseFloat(img.getAttribute('data-x') || 0)) * 3.84),
          y: parseInt((img.offsetTop + parseFloat(img.getAttribute('data-y') || 0)) * 3.84),
          w: parseInt(img.offsetWidth * 3.84),
          h: parseInt(img.offsetHeight * 3.84),
        };
      console.log(image);
    },

    async getTemplateInformations() {
      const { VUE_APP_API_HOST } = process.env
      let img = document.getElementsByClassName('image-news')[0];

      for (let k = 0; k < this.layers.length; k++) {
        if (this.layers[k].url) {
          continue
        }
        let formData = new FormData()
        formData.append('file', this.layers[k].file)

        await this.$http
          .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
            progress: (e) => {
                if (e.lengthComputable) {
                    console.log(Math.floor(e.loaded / e.total * 100));
                    this.percentUpload = Math.floor(e.loaded / e.total * 100)
                }
            }
          })
          .then(res => {
            this.layers[k].url = res.body.file_url
          }, err => err)
      }
      
      let bodylayers = this.layers.map((e,i) => {
        let element = document.getElementById(`layer-${i}`);
        return {
          x: parseInt((element.offsetLeft + parseFloat(element.getAttribute('data-x') || 0)) * 3.84),
          y: parseInt((element.offsetTop + parseFloat(element.getAttribute('data-y') || 0)) * 3.84),
          w: parseInt(element.offsetWidth * 3.84),
          h: parseInt(element.offsetHeight * 3.84),
          url: e.url
        }
      });

      let txtEl = document.getElementsByClassName('title-news')[0];
      let linkEl = document.getElementById('link-container');
      const body = {
        image: {
          x: parseInt((img.offsetLeft + parseFloat(img.getAttribute('data-x') || 0)) * 3.84),
          y: parseInt((img.offsetTop + parseFloat(img.getAttribute('data-y') || 0)) * 3.84),
          w: parseInt(img.offsetWidth * 3.84),
          h: parseInt(img.offsetHeight * 3.84),
        },
        layers: bodylayers,
        text: {
           x: parseInt(((txtEl.offsetLeft + parseFloat(txtEl.getAttribute('data-x') || 0)) + parseFloat(txtEl.offsetWidth / 2)) * 5.12),
           y: parseInt(((txtEl.offsetTop + parseFloat(txtEl.getAttribute('data-y') || 0)) + parseFloat(txtEl.offsetHeight / 2)) * 5.12),
           w: parseInt(txtEl.offsetWidth * 5.12),
           h: parseInt(txtEl.offsetHeight * 5.12),
          ...this.textProperties
        },
        link: {
          x: parseInt(((linkEl.offsetLeft + parseFloat(linkEl.getAttribute('data-x') || 0)) + parseFloat(linkEl.offsetWidth / 2)) * 5.12),
          y: parseInt(((linkEl.offsetTop + parseFloat(linkEl.getAttribute('data-y') || 0)) + parseFloat(linkEl.offsetHeight / 2)) * 5.12),
          w: parseInt(linkEl.offsetWidth * 5.12),
          h: parseInt(linkEl.offsetHeight * 5.12),
          custom_cta: this.custom_cta,
        },
        background: this.backgroundColor
      }
      return body;
    },

    removeLayer(idx) {
      this.layers.splice(idx, 1);
    },

    addNewLayer(event, index) {
      console.log(event.target.files, index);
      let files = event.target.files;
      console.log(files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        this.layers.push({
          reader: e.target.result,
          file: files[0],
        })
      };
      reader.readAsDataURL(files[0]);
    },

    imageResizeHandle(event) {
      let target = event.target
      let x = parseFloat(target.getAttribute('data-x')) || 0
      let y = parseFloat(target.getAttribute('data-y')) || 0

      // update the element's style
      target.style.width = event.rect.width + 'px'
      target.style.height = event.rect.height + 'px'

      // translate when resizing from top or left edges
      x += event.deltaRect.left
      y += event.deltaRect.top

      target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
      target.textContent =
        Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
    },

    imageDragHandle(event) {
      var target = event.target
      // keep the dragged position in the data-x/data-y attributes
      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      // translate the element
      target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    }
  }
}
</script>
